import { createTypedOutlet } from "src/router";

import { FunctionVersion } from "./types";

export type FunctionOutletContext = { function: FunctionVersion };

const {
  OutletProvider: FunctionOutlet,
  useContext: useFunctionOutletContext,
  useOptionalContext: useFunctionOutletContextIfAvailable,
} = createTypedOutlet<FunctionOutletContext>("Function");

export {
  FunctionOutlet,
  useFunctionOutletContext,
  useFunctionOutletContextIfAvailable,
};
